define('models/accounts/accounttransactiondata',['backbone',
    "models/accounts/accounttransaction_collection"
], function (Backbone, TransactionList) {
    var AccountTransactionData = Backbone.Model.extend({
        initialize: function (options) {
            options = options || {};

            this.AGID = options.AGID;
            this.PN = options.PN;
            this.SD = options.SD;
            this.ED = options.ED;
            this.SB = options.SB;
            this.EB = options.EB;
            this.ATID = options.ATID;
        },
        url: function (pn, startdate, enddate) {
            var url = pf.consumerURL + "/Accounts/TX";
            if (pn != null) {
                url += "?pn=" + pn;
            }
            else {

                url += "?pn=" + 1;
            }
            if (startdate != null) {
                url += "&startdate=" + startdate;
            }
            if (enddate != null) {
                url += "&enddate=" + enddate;
            }
            return url;
        },
        parse: function (data) {
            var response = {};
            data = data || {};
            response.StartingBalance = data.SB;
            response.EndingBalance = data.EB;
            response.transaction_list = data.TL;
            response.StartDate = data.SD;
            response.EndDate = data.ED;
            response.AccountTypeID = data.ATID;
						
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};            
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });
    return AccountTransactionData;
});
